export default `
§ sidebar.switch.team: Team
§ sidebar.switch.person: Employee
§ sidebar.buttons.settings: Settings
§ sidebar.buttons.print: Print
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: all time
§ sidebar.filters.year: year
§ sidebar.filters.halfYear: half year
§ sidebar.filters.month: month
§ sidebar.filters.week: week
§ sidebar.team.total: Common info
§ sidebar.team.scope: Features
§ sidebar.team.author: Employees
§ sidebar.team.type: Task types
§ sidebar.team.pr: Pull requests
§ sidebar.team.day: By day
§ sidebar.team.week: By week
§ sidebar.team.month: By month
§ sidebar.team.files: Files
§ sidebar.team.removedFiles: Removed files
§ sidebar.team.extension: Extensions
§ sidebar.team.tasks: Tasks
§ sidebar.team.release: Releases
§ sidebar.team.hours: Work schedule
§ sidebar.team.commits: All commits
§ sidebar.team.changes: All changes
§ sidebar.team.words: Popular words
§ sidebar.team.building: Quiz
§ sidebar.team.refactor: Refactoring
§ sidebar.team.company: Companies
§ sidebar.team.country: Locations
§ sidebar.team.settings: Settings
§ sidebar.person.total: Common info
§ sidebar.person.money: Work cost
§ sidebar.person.speed: Speed
§ sidebar.person.day: By day
§ sidebar.person.week: By week
§ sidebar.person.month: By month
§ sidebar.person.tasks: Tasks
§ sidebar.person.hours: Work schedule
§ sidebar.person.commits: All commits
§ sidebar.person.changes: All changes
§ sidebar.person.words: Popular words
§ sidebar.person.settings: Settings
`;
